import {Hub, HubProperties} from 'yougile-model'

export class BoardMessageStats {
  static turnOn(board: Hub) {
    board.properties[HubProperties.showMessageStatsInBoard] = true
    board.commit()
  }

  static turnOff(board: Hub) {
    delete board.properties[HubProperties.showMessageStatsInBoard]
    board.commit()
  }
}
